export default "__VITE_ASSET__012c4179__"